import { useEffect } from 'react';

import { useSocketConnectionContext } from '@web/components/SocketConnectionProvider/SocketConnectionProvider';
import { OutgoingCommand } from '@web/components/SocketConnectionProvider/types/command';
import { useConversationState } from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';

export const useActivityListener = () => {
  const { id } = useConversationState();
  const { send } = useSocketConnectionContext();

  useEffect(() => {
    const room = `conversation:${id}` as const;

    send({
      command: OutgoingCommand.CONVERSATION_JOIN,
      room,
    });

    return () => {
      send({
        command: OutgoingCommand.CONVERSATION_LEAVE,
        room,
      });
    };
  }, [id, send]);
};
